import React from 'react';

interface ShortcutsModalProps {
  onClose: () => void;
}

export default class ShortcutsModal extends React.Component<ShortcutsModalProps> {
  render() {
    const { onClose } = this.props;

    const shortcuts = [
      { key: 'Space', action: 'Play / Pause' },
      { key: '→', action: 'Next Frame' },
      { key: '←', action: 'Previous Frame' },
      { key: '↑', action: 'Increase FPS' },
      { key: '↓', action: 'Decrease FPS' },
      { key: 'Cmd + →', action: 'Rotate Layer Right' },
      { key: 'Cmd + ←', action: 'Rotate Layer Left' },
      { key: 'Cmd + ↑', action: 'Scale Layer Up' },
      { key: 'Cmd + ↓', action: 'Scale Layer Down' },
      { key: 'Cmd + Z', action: 'Undo' },
      { key: 'Cmd + Y', action: 'Redo' },
    ];

    return (
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h2>Keyboard Shortcuts</h2>
            <button onClick={onClose} className="modal-close" aria-label="Close">×</button>
          </div>
          <div className="shortcuts-list">
            {shortcuts.map((shortcut, i) => (
              <div key={i} className="shortcut-item">
                <kbd>{shortcut.key}</kbd>
                <span>{shortcut.action}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}
